var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicSlash = function SvgMicSlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 6.44V6a4.5 4.5 0 1 0-9 0v6c0 .972.308 1.872.832 2.607L7.26 15.68A5.974 5.974 0 0 1 6 12v-1.5a.75.75 0 0 0-1.5 0V12c0 1.801.635 3.454 1.693 4.747L3.22 19.72a.75.75 0 1 0 1.06 1.06l16.5-16.5a.75.75 0 0 0-1.06-1.06L16.5 6.44ZM15 7.94V6a3 3 0 1 0-6 0v6c0 .556.151 1.077.415 1.524L15 7.939Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79 17.58A6 6 0 0 0 18 12v-1.5a.75.75 0 0 1 1.5 0V12a7.501 7.501 0 0 1-6.75 7.463v2.287a.75.75 0 0 1-1.5 0v-2.287a7.452 7.452 0 0 1-2.188-.56c-.465-.199-.541-.799-.183-1.156.237-.238.6-.29.911-.167Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 11.25A.75.75 0 0 0 15 12a3 3 0 0 1-3 3 .75.75 0 0 0 0 1.5 4.5 4.5 0 0 0 4.5-4.5.75.75 0 0 0-.75-.75Z"
  })));
};
export default SvgMicSlash;